import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { Outlet } from 'react-router-dom';
import { sanitisedRoutesOfAccount } from '~/routes/groups/account';
import Navvy from './navvy';
import { NavSmartActions } from '~/components/nav/nav-smart-actions';
import useSmartNav from '~/hooks/use-smart-nav';
import DesktopTitledLayout from './desktop-layout';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import RequireCustomer from './require-customer';
import { Suspense } from 'react';
import MobileLayout from './mobile-layout';

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { showSmartActions } = useSmartNav();
  const { t } = useTranslation(TranslationNamespaces.MYACCOUNT);

  if (isXs) {
    return (
      <MobileLayout>
        {showSmartActions && (
          <Suspense>
            <RequireCustomer isXs={isXs} silent={true}>
              <NavSmartActions isXs={isXs} wrapper={(x) => <>{x}</>} contained={false} />
            </RequireCustomer>
          </Suspense>
        )}
        <Outlet />
      </MobileLayout>
    );
  }

  return (
    <DesktopTitledLayout title={t('ACCOUNT_AREA_TITLE', { defaultValue: 'Account' })}>
      <Suspense>
        <Navvy routes={sanitisedRoutesOfAccount} prefix="SETTINGS" />
      </Suspense>
      {showSmartActions && (
        <Suspense>
          <RequireCustomer isXs={isXs} silent={true}>
            <NavSmartActions isXs={isXs} wrapper={(x) => <>{x}</>} contained={false} />
          </RequireCustomer>
        </Suspense>
      )}
      <Outlet />
    </DesktopTitledLayout>
  );
}

Component.displayName = 'My Settings';
